<template>
  <div>
    <div class="filter" :class="className">
      <TreeSelect
        v-if="type === 1"
        class="treeSelect"
        placeholder="请选择专业"
        :defaultValue="professionList"
        @handleCheckboxChange="handleCheckboxChange"/>
      <a-input-search allowClear v-model="selected.keyword" placeholder="请输入资源名称" @change="onSearch" v-if="type !== 3">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="selected.keyword" slot="suffix" @click="selected.keyword = undefined, onSearch()" :src="require('@/assets/icons/icon_gb.png')" />
        <a-button class="search-btn" slot="enterButton">
          搜索
        </a-button>
      </a-input-search>
      <a-button type="primary" v-else @click="massUpload">上传资源</a-button>
    </div>
    <div v-if="type !== 2" class="filter between">
      <div class="resourceType">
        <div class="label">资源类型：</div>
        <div class="list" v-for="item in resourceTypeList" :key="item.id">
          <span :class="selected.resType === item.id ? 'selected':''" @click="typeChange(item.id)">{{item.name}}</span>
        </div>
      </div>
      <div class="auth" v-if="type === 1">
        <span class="label">显示授权资源：</span>
        <a-switch v-model="selected.isAuth" @change="onChange" />
      </div>
      <a-input-search allowClear v-model="selected.keyword" placeholder="请输入资源名称" @change="onSearch" v-if="type === 3">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="selected.keyword" slot="suffix" @click="selected.keyword = undefined, onSearch()" :src="require('@/assets/icons/icon_gb.png')" />
        <a-button class="search-btn" slot="enterButton">
          搜索
        </a-button>
      </a-input-search>
    </div>
    <!--批量上传-->
    <a-modal v-model="massUploadvisible" title="批量上传" width="515px" :footer="null" @ok="massUploadHandleOk" @cancel="massUploadHandleOk">
      <MassUpload ref="MassUpload" @ok="onSearch(1)" @hideVisible="massUploadvisible = false" @changeMassUploadvisible="visible => (massUploadvisible = visible)" />
    </a-modal>
  </div>
</template>
<script>
import { resTypeMap } from '@/api/lesson'
import TreeSelect from '@/components/treeSelect/index2.vue'
import MassUpload from '@/views/resource/private/components/MassUpload.vue'

export default {
  components: {
    TreeSelect,
    MassUpload
  },
  props: {
    className: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      type: 1,
      selected: {
        resType: '',
        isAuth: true,
        profession: [],
        keyword: undefined
      },
      resourceTypeList: [],
      massUploadvisible: false
    }
  },
  mounted() {
    this.getResTypeMap()
  },
  methods: {
    massUpload() {
      this.massUploadvisible = true
      this.$nextTick(() => {
        this.$refs.MassUpload.showModal()
      })
    },
    massUploadHandleOk() {
      this.$refs.MassUpload.handleOk()
    },
    handleTypeChange(key) {
      this.type = key
      this.selected = {
        resType: '',
        isAuth: true,
        profession: [],
        keyword: undefined
      }
      this.$emit('handleChange', this.selected)
    },
    onChange() {
      this.$emit('handleChange', this.selected)
    },
    onSearch() {
      this.selected.resType = ''
      this.$emit('handleChange', this.selected)
    },
    handleCheckboxChange(el) {
      this.selected.resType = ''
      const list = []
      el.forEach(item => {
        const obj = {
          V1: item.V1 ? Number(item.V1) : undefined,
          V2: item.V2 ? Number(item.V2) : undefined,
          V3: item.V3 ? Number(item.V3) : undefined
        }
        list.push(obj)
      })
      this.selected = Object.assign(this.selected, {
        profession: [...list]
      })
      this.$emit('handleChange', this.selected)
    },
    typeChange(id) {
      this.selected.resType = id
      this.$emit('handleChange', this.selected)
    },
    getResTypeMap() {
      resTypeMap().then(res => {
        this.resourceTypeList = res.data.list.splice(0, 6)
        this.resourceTypeList.unshift({
          id: '',
          name: '全部'
        })
      })
    }
  },
  activated() {
    this.selected.isAuth = true
  }
}
</script>

<style lang="less" scoped>
.filter{
  display: flex;
  align-items: flex-end;
  /deep/.ant-input-group-wrapper{
    width: 330px;
    height: 35px;
    position: relative;
    .ant-input-prefix{
      // right: auto;
      left: 16px;
      img{
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 69px;
      .anticon.anticon-close-circle.ant-input-clear-icon{
        display: none;
      }
      .clear{
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search{
      width: 100%;
      height: 35px;
      .ant-input{
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-radius: 20px;
        box-shadow: none;
        border: 1px solid #D8DCE0;
        &:focus{
          border-color: #ffb829;
          box-shadow: 0 0 0 2px rgba(255, 160, 0, 0.2);
        }
      }
    }
    .ant-input-group-addon {
      position: absolute;
      right: 63px;
      top: 0;
      border-radius: 20px;
      z-index: 2;
      background: none;
      .search-btn{
        border-left: 0;
        height: 35px;
        border-color: rgba(0, 0, 0, 0);
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        background: none;
        &::after{
          content: none;
        }
        span{
          display: flex;
          font-size: 14px;
          color: #333333;
          position: relative;
          align-items: center;
          &::before{
            left: -8px;
            content: '';
            width: 1px;
            height: 15px;
            background: #E9E9E9;
            position: absolute;
          }
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
}
.flexEnd{
  justify-content: flex-end;
}
.between{
  justify-content: space-between;
}
.resourceType{
  display: flex;
  margin-top: 20px;
  align-items: center;
  .label{
    font-size: 12px;
    font-weight: 400;
    color: #596777;
    line-height: 17px;
  }
  .list span{
    color: #000;
    display: flex;
    font-size: 14px;
    cursor: pointer;
    padding: 2px 10px 7px;
  }
}
.treeSelect{
  margin-right: 22px;
}
.auth{
  display: flex;
  font-weight: 500;
  color: #000000;
  line-height: 20px;
  align-items: center;
  /deep/.ant-switch{
    width: 58px;
    height: 28px;
    background: #E0E6EA;
    &::after{
      width: 24px;
      height: 24px;
    }
  }
  /deep/.ant-switch.ant-switch-checked{
    background: #FF6D00;
  }
  .label{
    font-size: 14px;
    font-weight: 550;
    color: #000000;
    line-height: 20px;
  }
}
.selected{
  font-weight: 550;
  color: #000000;
  position: relative;
  justify-content: center;
  &::after{
    bottom: -4px;
    content: '';
    width: 23px;
    height: 4px;
    background: #FF6D00;
    border-radius: 3px;
    position: absolute;
  }
}
/deep/ .ant-input-group:focus{
  border: 1px solid #3180ce;
}
</style>
